import { Controller } from '@hotwired/stimulus';

class FormController extends Controller {
	connect() {
		this.boundClearError = this.clearError.bind(this);

		this.inputTargets.forEach((input) => {
			input.addEventListener('keydown', this.boundClearError);
			input.addEventListener('change', this.boundClearError);
		});
	}

	/**
	 * Display errors.
	 *
	 * @param {*} errors
	 * @param {*} target
	 */
	displayErrors(errors, target = false) {
		if (!target) {
			target = this.errorNoticeTarget;
		}

		if (target) {
			target.innerHTML = '';
		}

		Object.keys(errors).forEach((key) => {
			this.displayFieldError(errors[key]);
			this.displayNoticeError(errors[key], target);
		});
	}

	/**
	 * Display notice error.
	 *
	 * @param {*} error
	 * @param {*} target
	 */
	displayNoticeError(error, target) {
		if (!target || error.field != 'notice') {
			return;
		}

		target.innerHTML = target.innerHTML + error.message;
	}

	/**
	 * Display field error.
	 *
	 * @param {*} error
	 */
	displayFieldError(error) {
		if (!this.fieldTargets) {
			return;
		}

		this.fieldTargets.forEach(function (field) {
			if (!field.querySelector('[name="' + error.field + '"]') && !field.querySelector('[name="' + error.field + '[]"]')) {
				return;
			}

			field.setAttribute('data-group-error', true);

			const fieldError = field.querySelector('.form-field-error');

			if (fieldError) {
				fieldError.innerHTML = error.message;
			}
		});
	}

	/**
	 * Clear error.
	 *
	 * @param {Event} e
	 */
	clearError(e) {
		e.target.closest('[data-' + this.context.module.definition.identifier + '-target=field]').removeAttribute('data-group-error');
	}

	/**
	 * Select element from list of inputs.
	 *
	 * @param {String} name
	 * @param {NodeList} inputs
	 *
	 * @returns Element
	 */
	selectFromInputs(name, inputs) {
		var returnInput = false;

		inputs.forEach(function (input) {
			if (input.name === name) {
				returnInput = input;
			}
		});

		return returnInput;
	}

	/**
	 * Select field from input name.
	 *
	 * @param {String} name
	 * @param {NodeList} inputs
	 * @param {NodeList} fields
	 *
	 * @returns Element
	 */
	selectFieldFromInput(name, inputs, fields) {
		var returnField = false;

		inputs.forEach(function (input) {
			if (input.name === name) {
				fields.forEach(function (field) {
					if (field.contains(input)) {
						returnField = field;
					}
				});
			}
		});

		return returnField;
	}
}

export { FormController };
